export default "__VITE_ASSET__a938f299__"